import * as React from 'react';

function SvgWarning(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.93 21.9" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M13.47.89l10.24 18.53a1.58 1.58 0 010 1.66 1.73 1.73 0 01-.63.6 1.66 1.66 0 01-.84.23H1.73a1.67 1.67 0 01-.85-.23 1.7 1.7 0 01-.62-.6 1.56 1.56 0 010-1.66L10.48.89a1.69 1.69 0 012.36-.65 1.71 1.71 0 01.63.65zm.18 12.29l.24-6a.28.28 0 00-.13-.25.51.51 0 00-.32-.15H10.5a.54.54 0 00-.32.15.33.33 0 00-.13.28l.23 6a.25.25 0 00.13.22.66.66 0 00.32.08h2.47a.59.59 0 00.31-.08.29.29 0 00.14-.25zm0 4.92v-2.5a.42.42 0 00-.13-.31.41.41 0 00-.3-.12h-2.53a.44.44 0 00-.3.12.46.46 0 00-.13.31v2.5a.42.42 0 00.13.31.41.41 0 00.3.13h2.56a.38.38 0 00.3-.13.39.39 0 00.13-.31z" />
    </svg>
  );
}

const MemoSvgWarning = React.memo(SvgWarning);
export default MemoSvgWarning;
